var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{staticClass:"uk-fieldset"},[_c('legend',{staticClass:"uk-legend"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"box"},[_vm._t("default",function(){return [_vm._v("EMPTY")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }